import React from 'react'
import { EmptyListDateTime, format, formatDateTime } from '@cbgms/base/utils/datetime'

export interface IDateTimeCell {
  content: string
}

export const DateTimeCell: React.FC<IDateTimeCell> = props => {
  return props.content !== EmptyListDateTime ? <>{formatDateTime(props.content, format.fullDateTime)}</> : null
}

export default React.memo(DateTimeCell)
